import { View } from 'foundations-components/components/View';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { device } from '../../../constants/StyledComponentConstants';
// @ts-expect-error js file is not typed
import useMediaQuery from '../../../hooks/useMediaQuery';
import { FaceNavPortalPickerSubmenu } from './FaceNavPortalPickerSubmenu';
import { usePortalAccounts } from '../hooks/usePortalAccounts';
import { FaceNavPortalPickerMenuButton } from './FaceNavPortalPickerMenuButton';
import { useHoverIntent } from '../hooks/useHoverIntent';
import { useState, useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FaceNavPortalPicker = () => {
  const isTablet = useMediaQuery(device.tablet);
  const {
    currentAccount,
    remainingAccounts,
    isLoading
  } = usePortalAccounts();
  const {
    isHoveredWithIntent,
    onMouseEnter,
    onMouseLeave,
    disableHoverUntilMouseMove
  } = useHoverIntent({
    submenuElementQuery: '[id="face-nav-portal-picker-menu"]',
    triggerElementQuery: '[id="face-nav-portal-picker-trigger"]'
  });
  const [isClickOpen, setIsClickOpen] = useState(false);
  const isOpen = isHoveredWithIntent || isClickOpen;
  const handleClick = useCallback(() => {
    if (isHoveredWithIntent) {
      disableHoverUntilMouseMove();
      setIsClickOpen(false);
    } else {
      setIsClickOpen(prev => !prev);
    }
  }, [disableHoverUntilMouseMove, isHoveredWithIntent]);
  if (isLoading || !currentAccount || !remainingAccounts) {
    return null;
  }
  const trigger = /*#__PURE__*/_jsx(FaceNavPortalPickerMenuButton, {
    isOpen: isOpen,
    onClick: handleClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    portalId: currentAccount.id,
    portalName: currentAccount.accountName
  });
  const content = /*#__PURE__*/_jsx(FaceNavPortalPickerSubmenu, {
    accounts: remainingAccounts,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  });
  if (remainingAccounts.length === 0) {
    return null;
  }
  if (isTablet) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [trigger, isOpen && /*#__PURE__*/_jsx(View, {
        borderBlockEndStyle: "solid",
        borderBlockEndWidth: "100",
        borderColor: "border-core-default",
        children: content
      })]
    });
  }
  return /*#__PURE__*/_jsx(Popover, {
    arrowSize: "none",
    autoPlacement: false,
    content: content,
    marginInlineEnd: "300",
    onOpenChange: evt => setIsClickOpen(evt.target.value),
    open: isOpen,
    placement: "left bottom",
    children: trigger
  });
};